import script from "./VChatInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./VChatInput.vue?vue&type=script&setup=true&lang=ts"

import "./VChatInput.vue?vue&type=style&index=0&id=eaae465e&lang=scss"

const __exports__ = script;

export default __exports__